module.exports = __webpack_public_path__ + "media/application/images/2018/2018-related-2fd0908edc1618a8646f39a76fc8d47a.jpg";